import { $$ } from "@utils/dom";

import Module from "../module/Module";
import PbRowFeaturedPosts from "./PbRowFeaturedPosts";

export const SELECTOR = `[data-pb-row-featured-posts]`;

class Factory extends Module {
  constructor(init = false) {
    super();

    this.initialized = false;
    this.items = null;

    init ? this.init() : null;
  }

  get name() {
    return "PbRowFeaturedPosts";
  }

  init() {
    this.initialized = true;
    this.items = [...$$(SELECTOR)].map((el) => new PbRowFeaturedPosts(el, this.emitter));
  }

  destroy() {
    if (this.items) this.items.forEach((el) => el.destroy());
    this.initialized = false;
    this.items = null;
  }
}

export default Factory;
